import React from 'react'
import { t } from 'i18next'

import { Button, Icon, Text } from '@ui'

import { TableConfigTooltip } from './TableConfigTooltip'
import { Export } from './Export'

import './style.scss'
import { isValue } from '@app/util'

const DISABLE_ALL_FILTERS_CONTAINER = Object.freeze({ cursor: 'pointer', display: 'flex', gap: '0.5rem', alignItems: 'center', flexShrink: 0, flexGrow: 1, paddingInline: '0.5rem' })

export const ActionBar = ({
  showActionBar,
  editedRows,
  extraButtonContent,
  allColumns,
  setHiddenColumns,
  exportHidden,
  exportFileName,
  tableName,
  selectedFlatRows,
  getTransformedColumns,
  onBatchActions,
  batchActionsDisabled,
  hiddenColumns,
  showConfig,
  filters,
  setAllFilters
}) => {
  const showDisableFiltersButton = isValue(filters) && Array.isArray(filters) && filters.length > 0

  return (
    <div className='ds-table-detachable-node'>
      <div className='table-action-bar'>
        {showDisableFiltersButton &&
          <div onClick={() => setAllFilters([])} style={DISABLE_ALL_FILTERS_CONTAINER}>
            <Text>{t('CAL_FILTERS_DISABLE_ALL')} ({filters?.length ?? 0})</Text>
          </div>}
        {showActionBar && editedRows.length === 0 && (
          <>
            {extraButtonContent && (
              <div className='with-extra'>
                {extraButtonContent}
              </div>
            )}
            <div className='static-buttons'>
              {showConfig && (
                <TableConfigTooltip
                  allColumns={allColumns}
                  setHiddenColumns={setHiddenColumns}
                  hiddenColumns={hiddenColumns}
                />
              )}
              {!exportHidden && (
                <Export
                  tableName={tableName}
                  selectedRows={selectedFlatRows}
                  columns={hiddenColumns?.length ? getTransformedColumns.filter(col => !hiddenColumns.includes(col.accessor)) : getTransformedColumns}
                  exportFileName={exportFileName}
                />
              )}
              {onBatchActions && (
                <Button
                  disabled={batchActionsDisabled || !selectedFlatRows.length}
                  ico={Icon.ICONS.edit}
                  onClick={() => onBatchActions(selectedFlatRows)}
                  label={t('TABLE_BATCH_EDIT')}
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}
